import styled from "styled-components";
import {Tabs, Card, Button, Drawer, DatePicker, Table, Descriptions, Row, Col} from "antd";

export const Img = styled.img`
    height: 150px;
    display: flex;
    margin: auto;
    border-radius: 50%;
    border: 10px solid #fafafa;
    box-sizing: content-box;
`;

export const ImageWrapper = styled.div`
    position: relative;
    width: 165px;
    height: 210px;
    margin: auto;
    cursor: pointer;
    border-radius: 50%;
    border: 10px solid #fafafa;
    box-sizing: content-box;
    overflow: hidden;

    &:hover .overlay {
        opacity: 1;
    }
`;

export const ImageProfile = styled.img`
    width: 100%;
    height: 100%;
    border-radius: 50%;
    object-fit: cover;
    object-position: center;
    display: block;
`;

export const Overlay = styled.div`
    position: absolute;
    inset: 0;
    background-color: rgba(0, 0, 0, 0.4);
    border-radius: 50%;
    display: flex;
    align-items: center;
    justify-content: center;
    opacity: 0;
    transition: opacity 0.3s;
`;

export const TableContainer = styled(Table)`
    .ant-table-tbody > tr > td {
        min-width: 100px;
    }
    
    @media (max-width: 768px) {
        .ant-table-tbody > tr > td {
            min-width: 80px;
            font-size: 11px;
            padding: 8px;
        }
        
        .ant-table-thead > tr > th {
            font-size: 11px;
            padding: 8px;
        }
    }
`;

export const TimelineCard = styled(Card)`
    width: 60%;
    float: ${props => props.right === "true" && "right"};
    .ant-card-body {
        padding: 12px;
    }
    
    @media (max-width: 768px) {
        width: 100% !important;
        float: none !important;
        max-width: 100% !important;
        margin: 0 !important;
        
        .ant-card-body {
            padding: 10px;
            font-size: 12px;
            word-wrap: break-word;
            overflow-wrap: break-word;
        }
        
        .ant-card-head {
            padding: 8px 10px;
            font-size: 12px;
        }
        
        .ant-card-head-title {
            font-size: 12px;
            padding: 0;
        }
    }
`;

export const LeftButton = styled(Button)`
    padding: 0px 8px;
    font-size: 12px;
    margin: 10px 0;
    @media (max-width: 768px) {
        width: 100%;
    }
`;

export const DrawerContainer = styled(Drawer)`
    position: absolute;
`;

export const PastTabContainer = styled.div`
    min-height: max(calc(100vh - 260px), 500px);
    
    @media (max-width: 768px) {
        min-height: max(calc(100vh - 200px), 400px);
        
        .ant-timeline-item {
            padding-bottom: 20px;
        }
        
        .ant-timeline-item-tail {
            left: 4px;
        }
        
        .ant-timeline-item-head {
            left: 4px;
        }
        
        .ant-timeline-item-content {
            margin-left: 20px;
            width: calc(100% - 20px);
            overflow: visible;
        }
        
        .ant-timeline-item-label {
            position: static !important;
            width: 100% !important;
            text-align: left !important;
            margin: 0 0 8px 20px !important;
            padding: 0 !important;
        }
    }
`;

export const DateRangePicker = styled(DatePicker)`
    width: 100%;
`;

export const TableTitle = styled.h3`
    margin-top: 20px;
    margin-bottom: 15px;
`;

export const RightButton = styled(Button)`
    float: right;
`;

export const TimeLineDuration = styled.p`
    font-size: 13px;
    font-weight: bold;
    
    @media (max-width: 768px) {
        font-size: 11px;
        margin-top: 4px;
        margin-bottom: 8px;
    }
`;

export const DescriptionContainer = styled(Descriptions)`
    margin-bottom: 20px;
    border-left: 2px solid ${props => props.color};
    
    @media (max-width: 768px) {
        margin-bottom: 12px;
        font-size: 12px;
        
        .ant-descriptions-item-label {
            font-size: 11px;
            padding: 8px 12px;
        }
        
        .ant-descriptions-item-content {
            font-size: 12px;
            padding: 8px 12px;
        }
    }
`;
export const ColoredLine = styled.div`
    position: absolute;
    top: 11px;
    left: -17px;
    background-color: ${props => props.color};
    width: 19px;
    height: 2px;
    
    @media (max-width: 768px) {
        left: -12px;
        width: 14px;
    }
`;

export const TabsContainer = styled(Tabs)`
    @media (max-width: 1200px) {
        .ant-tabs-nav {
            flex-wrap: wrap;
        }
        .ant-tabs-nav > .ant-tabs-extra-content {
            width: 100%;
        }
        .ant-tabs-nav > .ant-tabs-extra-content > div > div {
            display: flex;
            flex-direction: column;
        }
    }
    @media (max-width: 768px) {
        .ant-tabs-nav > .ant-tabs-extra-content > div > div {
            width: 100%;
            display: flex;
            flex-direction: column;
        }
    }
`;

export const TopContainer = styled(Row)`
    margin-top: 20px;
    margin-bottom: 20px;
`;

export const EditButton = styled(Button)`
    background-color: black;
    border: 0;
    &:hover {
        background-color: rgba(0, 0, 0, 0.7);
    }
`;

export const SelectContainer = styled(Row)`
    margin-bottom: 10px;
`;

export const CourierPersonalInfoRow = styled(Row)`
    font-size: 14px;
    font-weight: normal;
    justify-content: center;
    margin-bottom: 8px;
`;

export const CourierPersonalInfoContainer = styled(Row)`
    width: 100%;
    margin-bottom: 0;
    display: flex;
    justify-content: center;

    @media (max-width: 768px) {
        margin-bottom: 0;
    }

    @media (max-width: 576px) {
        margin-bottom: 0;
    }

    @media (max-width: 480px) {
        margin-bottom: 0;
    }
`;

export const CourierPersonalInfoItem = styled(Col)`
    margin-bottom: 6px;
    padding: 0 4px;

    @media (max-width: 992px) {
        padding: 0 4px;
        margin-bottom: 6px;
    }

    @media (max-width: 768px) {
        padding: 0 4px;
        margin-bottom: 6px;
    }

    @media (max-width: 576px) {
        padding: 0 3px;
        margin-bottom: 4px;
    }

    @media (max-width: 480px) {
        padding: 0 2px;
        margin-bottom: 4px;
    }
`;

export const PersonalInfoCard = styled(Card)`
    width: 100%;
    border-radius: 8px;
    box-shadow: 0 2px 4px rgba(0, 0, 0, 0.1);
    transition: box-shadow 0.3s ease;
    border: 1px solid #f0f0f0;
    min-height: 50px;
    display: flex;
    flex-direction: column;

    &:hover {
        box-shadow: 0 4px 8px rgba(0, 0, 0, 0.15);
    }

    .ant-card-body {
        padding: 2px 6px;
        display: flex;
        flex-direction: column;
        justify-content: center;
        align-items: center;
        text-align: center;
        flex: 1;
    }

    .info-label {
        font-size: 10px;
        color: #8c8c8c;
        margin-bottom: 2px;
        font-weight: 500;
        text-transform: uppercase;
        letter-spacing: 0.3px;
        flex-shrink: 0;
        width: 100%;
        word-break: break-word;
        word-wrap: break-word;
        white-space: normal;
        overflow-wrap: break-word;
        line-height: 1.3;
    }

    .info-value {
        font-size: 11px;
        color: #262626;
        font-weight: 600;
        word-break: break-word;
        word-wrap: break-word;
        white-space: normal;
        line-height: 1.4;
        width: 100%;
        overflow-wrap: break-word;
        hyphens: auto;
    }

    /* Tablet */
    @media (max-width: 992px) {
        min-height: 60px;
        border-radius: 6px;

        .ant-card-body {
            padding: 4px 6px;
        }

        .info-label {
            font-size: 9px;
            margin-bottom: 2px;
            letter-spacing: 0.2px;
            line-height: 1.2;
        }

        .info-value {
            font-size: 10px;
            line-height: 1.4;
        }
    }

    /* Tablet ve küçük ekranlar */
    @media (max-width: 768px) {
        min-height: 65px;

        .ant-card-body {
            padding: 4px 6px;
        }

        .info-label {
            font-size: 9px;
            margin-bottom: 2px;
            letter-spacing: 0.2px;
            line-height: 1.2;
        }

        .info-value {
            font-size: 10px;
            line-height: 1.4;
        }
    }

    /* Mobil */
    @media (max-width: 576px) {
        min-height: 70px;
        border-radius: 6px;

        .ant-card-body {
            padding: 4px 6px;
        }

        .info-label {
            font-size: 8px;
            margin-bottom: 2px;
            letter-spacing: 0.2px;
            line-height: 1.2;
        }

        .info-value {
            font-size: 10px;
            line-height: 1.4;
        }
    }

    /* Küçük mobil */
    @media (max-width: 480px) {
        min-height: 75px;
        border-radius: 4px;

        .ant-card-body {
            padding: 3px 5px;
        }

        .info-label {
            font-size: 7px;
            margin-bottom: 1px;
            letter-spacing: 0.15px;
            line-height: 1.2;
        }

        .info-value {
            font-size: 9px;
            line-height: 1.3;
        }
    }

    /* Çok küçük ekranlar */
    @media (max-width: 360px) {
        min-height: 80px;

        .ant-card-body {
            padding: 3px 4px;
        }

        .info-label {
            font-size: 7px;
            margin-bottom: 1px;
            letter-spacing: 0.1px;
            line-height: 1.1;
        }

        .info-value {
            font-size: 8px;
            line-height: 1.3;
        }
    }
`;

export const PhotoTabs = styled(Tabs)`
    .ant-tabs-nav {
        display: flex !important;
        justify-content: center !important;
    }

    .ant-tabs-nav-wrap {
        display: flex !important;
        justify-content: center !important;
        flex: auto !important;
    }

    .ant-tabs-nav-list {
        display: flex !important;
        justify-content: center !important;
        flex: auto !important;
    }

    @media (max-width: 992px) {
        .ant-tabs-nav-list {
            flex-direction: column !important;
        }
    }
`;
